import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


export default class  GeneralCostInfo extends React.Component  {

  render()
  {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Cost Information
        </Typography>
        <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="journey"
                name="journey"
                label="Journey (Hours/Day)"
                fullWidth
                autoComplete="journey"
                value={this.props.costinfo.journey}
                onChange={this.props.handleChange}
                disabled={this.props.reviewActive}
                error={this.props.errores.journey}
                helperText={this.props.errores.journey}
              />
            </Grid>
            <Grid item  xs={12} sm={6}>
              <TextField
                required
                id="hourly_rate"
                name="hourly_rate"
                label="Hourly Rate"
                fullWidth
                autoComplete="hourly_rate"
                value={this.props.costinfo.hourly_rate}
                onChange={this.props.handleChange}
                disabled={this.props.reviewActive}
                error={this.props.errores.hourly_rate}
                helperText={this.props.errores.hourly_rate}
              />
            </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

GeneralCostInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/features/cost/GenericCostInfo.js